import { CenteredBlocks } from "@components/site/CenteredBlocks"
import { ContentBlocks } from "eddev/blocks"
import { defineView } from "eddev/views"
import { PageProvider } from "../contexts/PageContext"
import { SiteFooter } from "@components/site/SiteFooter"

export default defineView("single-venue", (props) => {
  return (
    <PageProvider theme={"yellow"}>
      <CenteredBlocks contentBlocks={props.venue?.contentBlocks} />
      <SiteFooter />
    </PageProvider>
  )
})
